var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rails"},_vm._l((_vm.rails),function(n,i){return _c('div',{staticClass:"rail",style:(_vm.sty(i,n))},[_c('img',{attrs:{"src":'./static/front/'+ n.code +'.svg'}}),(_vm.preview === true)?_c('div',{staticClass:"code"},[_vm._v(_vm._s(n.code))]):_vm._e()])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0650aa08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front/Rails.vue
// module id = null
// module chunks = 